export default __webpack_public_path__ + "static/media/12.88ca04ac.PNG";